const initialState = {
  prompts: {
    verifyPrimary: false,
    affirmPrimary: false,
    addBackup: false,
    affirmBackup: false,
  },
  promptsLoaded: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case 'FETCH_EMAIL_VERIFICATION_PROMPTS_SUCCESS':
      return {
        ...state,
        prompts: {
          verifyPrimary: !!action.response.verifyPrimary,
          affirmPrimary: !!action.response.affirmPrimary,
          addBackup: !!action.response.addBackup,
          affirmBackup: !!action.response.affirmBackup,
        },
        promptsLoaded: true,
      }

    case 'DISMISS_EMAIL_VERIFICATION_PROMPT_SUCCESS':
      return {
        ...state,
        prompts: {
          ...state.prompts,
          [action.name]: false,
        },
      }

    case 'VERIFY_EMAIL_VERIFICATION_SUCCESS':
      return {
        ...state,
        prompts: {
          ...state.prompts,
          ...(action.response.prompts || {}),
        },
      }

    case 'LOGOUT':
      return initialState

    default:
      return state
  }
}
